import React, { useState } from 'react';
import FalconButtonV2 from '../../FalconButtonV2/FalconButtonV2';
import RichText from '../../richtext';
import Styles from './checkoutRedirectionPopup.module.scss';
import Cookies from 'js-cookie';
import { AssetPathPropConfig } from '../../../services/LineTableBasicPropConfig';
import LoginModalV2 from '../../login/LoginModalV2';

interface LoginPopupSchema {
  content: any;
  metadata: any;
  wafIdentifier: any;
  togglePopup?: any;
  isOpen?: any;
  validation?: any;
  onLoginSuccessRedirection?: any;
  isProdEnv?: boolean;
}
// eslint-disable-next-line max-lines-per-function
const checkoutRedirectionPopup = ({
  content,
  metadata,
  wafIdentifier,
  togglePopup,
  isOpen,
  validation,
  onLoginSuccessRedirection,
  isProdEnv
}: LoginPopupSchema) => {
  const [showLogin, setShowLogin] = useState<boolean>(false);
  const assetPath = AssetPathPropConfig?.getInstance()?.getAssetPath();
  let AuthData: any = typeof window !== undefined && Cookies.get('sunriseAuth');
  AuthData = AuthData && JSON.parse(AuthData);

  const closeLogin = () => {
    setShowLogin(!showLogin);
    togglePopup();
  };

  const onLoginSuccess = () => {
    setShowLogin(!showLogin);
    onLoginSuccessRedirection();
  };

  return (
    <>
      {showLogin && (
        <LoginModalV2
          content={content?.login_reference?.[0]}
          closeLogin={closeLogin}
          metadata={metadata}
          onSuccess={onLoginSuccess}
          isProdEnv={isProdEnv}
        />
      )}
      {isOpen && !showLogin && !AuthData?.authvalues && (
        <div className={Styles.wrapper}>
          <div className={Styles.container}>
            <img
              onClick={togglePopup}
              className={`${Styles.closeicon}`}
              src={`${assetPath}/icons/close.svg`}
              alt='close'
            />
            {/* new customer section */}
            <div>
              <img src={content?.customerIcon?.filename} width={40} height={40} alt='customerIcon'/>
              <div className={Styles.title}>{content?.sectionHeading}</div>
              <div className={Styles.description}>
                <RichText content={content?.sectionDescription} />
              </div>
              <div className={Styles['btn-wrapper']}>
                <FalconButtonV2
                  content={content?.CTA?.[0]}
                  className={Styles['fullWidth']}
                  onClick={validation}
                  iconPosition={content?.CTA?.[0]?.iconPosition}
                  wafIdentifier={wafIdentifier}
                />
              </div>
            </div>

            <div className={Styles.divider}></div>
            {/* existing customer section */}
            <div>
              <img src={content?.loginIcon?.filename} width={40} height={40} alt='loginIcon'/>
              <div className={Styles.title}>{content?.loginSectionHeading}</div>
              <div className={Styles.description}>{content?.loginSectionDescription}</div>
              <FalconButtonV2
                content={content?.loginCTA?.[0]}
                className={Styles['fullWidth']}
                onClick={() => setShowLogin(!showLogin)}
                wafIdentifier={wafIdentifier}
              />
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default checkoutRedirectionPopup;
